import { Metamodel } from '../base/model';
import { Transformation } from './transformation';
import { Collection } from '../base/annotation';

@Metamodel.model({
    name: 'group',
    display: ['group'],
    constraints: {
        name: {
            required: true
        }
    }
})
export class Group extends Transformation {

    @Metamodel.attribute({
        collection: Collection.Set
    })
    public readonly transformations = new Set<string>();

    constructor(name?: string, description?: string, id?: number, public _type?: string) {
        super(name, description, id);
    }

    public getAllTransformations(): Transformation[] {
        return this.owner.getAllTransformations().filter((transformation) => this.transformations.has(transformation.name));
    }

    protected getGeneratedDescription(): string {
        return this.description;
    }
}
